import React from 'react';
import ReactDOM from 'react-dom/client';
import { Root } from './App';
import { CartProvider } from './context/CartContext';
import './index.css';
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<React.StrictMode data-id="element-320">
    <CartProvider data-id="element-321">
      <Root data-id="element-322" />
    </CartProvider>
  </React.StrictMode>);